import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import analyticsService from './utils/analytics';

import Home from './containers/Home';
import Error from './containers/Error';
import Success from './containers/Success';
import Generate from './containers/Generate';

const WalletRoutes = () => {
    const [platform, setPlatform] = useState('');
    let digitalData = analyticsService.getDigitalData();

    useEffect(() => {
        if (navigator.userAgent.indexOf('Android') > -1) {
            setPlatform('android');
            digitalData['device_type'] = 'android';
        } else if (navigator.userAgent.indexOf('iPhone') > -1) {
            setPlatform('iphone');
            digitalData['device_type'] = 'iphone';
        } else {
            setPlatform('other');
            digitalData['device_type'] = 'other';
        }
        analyticsService.setDigitalData(digitalData);
    }, []);

    return (
        <React.Fragment>
            <Routes>
                <Route path='/' element={<Home platform={platform} />} />
                {/* <Route exact path="/:id" element={<Pass platform={platform} />} /> */}
                <Route exact path='/error' element={<Error />} />
                <Route exact path='/success' element={<Success platform={platform} />} />
                {/* <Route exact path='/generate' element={<Generate />} /> */}
            </Routes>
        </React.Fragment>
    )
}

export default WalletRoutes